import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import type { VersionBannerProps } from './VersionBanner.interfaces';
import styles from './VersionBanner.module.css';

export const VersionBanner = ({ onReload, onDismiss }: VersionBannerProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.banner}>
      <div className={styles.header}>
        <div className={styles.titleRow}>
          <span className={styles.errorDot}>✕</span>
          <span className={styles.title}>{t('global.labels.updateAvailable')}</span>
        </div>
        <Button type="text" size="small" className={styles.dismiss} onClick={onDismiss}>
          ✕
        </Button>
      </div>
      <p className={styles.description}>{t('global.labels.reloadToGetLatestVersion')}</p>
      <div className={styles.actions}>
        <Button color="danger" variant="outlined" size="small" onClick={onReload}>
          {t('global.buttons.reload')}
        </Button>
      </div>
    </div>
  );
};
